import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getEstadosCandidatosPr = query =>
	fetch.get(
		`/estados-candidatos-pr${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getEstadoCandidatoPr = ({ id, query }) =>
	fetch.get(
		`/estados-candidatos-pr/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addEstadoCandidatoPr = data =>
	fetch.post('/estados-candidatos-pr', data);
export const updateEstadoCandidatoPr = ({ id, ...data }) =>
	fetch.put(`/estados-candidatos-pr/${id}`, data);
export const deleteEstadoCandidatoPr = id =>
	fetch.delete(`/estados-candidatos-pr/${id}`);

// RTK Query
export const estadosCandidatosPrApi = createApi({
	reducerPath: 'estadosCandidatosPrApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getEstadosCandidatosPr: build.query({
			query: query => {
				return {
					url: `/estados-candidatos-pr${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'EstadosCandidatosPr',
								id,
							})),
							{ type: 'EstadosCandidatosPr', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'EstadosCandidatosPr', id: 'LIST' }],
		}),
		getEstadoCandidatoPr: build.query({
			query: ({ id, query }) => {
				return {
					url: `/estados-candidatos-pr/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [
				{ type: 'EstadosCandidatosPr', id },
			],
		}),
		addEstadoCandidatoPr: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-candidatos-pr`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success(
						'Estado Candidato Proceso agregado exitosamente'
					);
				} catch (error) {
					message.error('Error al agregar estado candidato proceso');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'EstadosCandidatosPr', id: 'LIST' }],
		}),
		updateEstadoCandidatoPr: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-candidatos-pr/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success(
						'Estado Candidato Proceso actualizado exitosamente'
					);
				} catch (error) {
					message.error('Error al actualizar estado candidato proceso');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'EstadosCandidatosPr', id },
			],
		}),
		deleteEstadoCandidatoPr: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-candidatos-pr/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success(
						'Estado Candidato Proceso eliminado exitosamente'
					);
				} catch (error) {
					message.error('Error al eliminar estado candidato proceso');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [
				{ type: 'EstadosCandidatosPr', id },
			],
		}),
	}),
});

export const {
	useGetEstadosCandidatosPrQuery,
	useGetEstadoCandidatoPrQuery,
	useAddEstadoCandidatoPrMutation,
	useUpdateEstadoCandidatoPrMutation,
	useDeleteEstadoCandidatoPrMutation,
} = estadosCandidatosPrApi;
